import { render, staticRenderFns } from "./NotesTemplate.vue?vue&type=template&id=3a619d8a&scoped=true"
import script from "./NotesTemplate.vue?vue&type=script&lang=js"
export * from "./NotesTemplate.vue?vue&type=script&lang=js"
import style0 from "./NotesTemplate.vue?vue&type=style&index=0&id=3a619d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a619d8a",
  null
  
)

export default component.exports